import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-block p-head-title ml-1 mt-1 text-capitalize" }
const _hoisted_2 = {
  key: 0,
  class: "mr-3 pa-1",
  "offset-x": "100"
}

import {useRouter} from 'vue-router';
import {reactive, watch} from 'vue';
import {useCartStore} from '@/api/store/cart';
import {useSettingsStore} from '@/api/store/settings';
import BackArrow from '../vectors/BackArrow.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  setup(__props) {

const settingsStore = useSettingsStore();
const router = useRouter();

const state = reactive({
  title: router.currentRoute.value.meta.title ? router.currentRoute.value.meta.title : router.currentRoute.value.name,
  bg: router.currentRoute.value.meta.colorTitleBar ? router.currentRoute.value.meta.colorTitleBar : settingsStore.settings.primaryColor,
  text: router.currentRoute.value.meta.textTitleBar ? router.currentRoute.value.meta.textTitleBar : '#FFF',
  showCart: router.currentRoute.value.meta.showCart ? router.currentRoute.value.meta.showCart : false,
});

watch(() => router.currentRoute.value.name, (val) => {
  state.title = router.currentRoute.value.meta.title ? router.currentRoute.value.meta.title : val;
  state.bg = router.currentRoute.value.meta.colorTitleBar ? router.currentRoute.value.meta.colorTitleBar : settingsStore.settings.primaryColor;
  state.text = router.currentRoute.value.meta.textTitleBar ? router.currentRoute.value.meta.textTitleBar : '#FFF';
  state.showCart = router.currentRoute.value.meta.showCart ? router.currentRoute.value.meta.showCart : false;
  getCartCountFromLocalStorage();
});

const getCartCountFromLocalStorage = () => {
  const cart = localStorage.getItem('cartItems');

  if (cart) {
    return Number(cart) || 0;
  }

  return 0
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    style: _normalizeStyle('height:55px;color: ' + state.text + ';background-color: ' + state.bg),
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "pt-2",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "d-flex justify-start align-center",
            cols: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(BackArrow, {
                class: "ml-5 back-arrow",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "d-flex justify-center align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(state.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex justify-end align-center",
            cols: "2"
          }, {
            default: _withCtx(() => [
              (state.showCart)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (getCartCountFromLocalStorage() > 0)
                      ? (_openBlock(), _createBlock(_component_v_badge, {
                          key: 0,
                          content: getCartCountFromLocalStorage(),
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              class: "mr-4",
                              end: "",
                              icon: "fa-shopping-cart d-block",
                              size: "20",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({name: 'shopping-cart'})))
                            })
                          ]),
                          _: 1
                        }, 8, ["content"]))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          class: "mr-4",
                          end: "",
                          icon: "fa-shopping-cart d-block",
                          size: "20",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({name: 'shopping-cart'})))
                        }))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})